<template>
  <div class="pa-4">
		<v-card elevation="0">
			<v-card-title>
        <a
          href="#"
          target="_blank"
          @click.prevent="getVirtualSensor('3049fddd-c0a9-491a-9d71-8e92f03b5112')">
          Download the last virtual sensor data
        </a>
			</v-card-title>
    </v-card>
  </div>
</template>

<script>
import api from "@/api/api.js";


export default {
	data() {
		return {

		};
	},
	computed: {

	},

	watch: {

	},

	mounted() {

	},

	methods: {

    async getVirtualSensor(repoId) {
      await api
        .getVirtualSensorFile(repoId)
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'virtual_sensor_last.csv');
          document.body.appendChild(link);
          link.click();
        }).catch(console.error)
    },

	},
};
</script>